var _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icons set"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Folder"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1434_9755",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Clip 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33398 3.33362H37.8283V37.7818H3.33398V3.33362Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1434_9755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.739 5.83362C7.89898 5.83362 5.83398 8.29362 5.83398 14.0553V27.0536C5.83398 32.3603 8.76398 35.282 14.084 35.282H27.054C32.3607 35.282 35.2823 32.3603 35.2823 27.0536V27.0486L35.329 18.7736C35.329 13.1086 33.3857 10.9003 28.394 10.9003H23.6773C22.0957 10.8986 20.5857 10.1436 19.6357 8.88029L18.114 6.85695C17.6357 6.21529 16.8707 5.83529 16.0707 5.83362H12.739ZM27.054 37.782H14.084C7.45398 37.782 3.33398 33.6703 3.33398 27.0536V14.0553C3.33398 6.94029 6.49898 3.33362 12.739 3.33362H16.0723C17.6573 3.33528 19.1673 4.09195 20.114 5.35695L21.6323 7.37695C22.114 8.01695 22.879 8.39862 23.679 8.40029H28.394C34.8307 8.40029 37.829 11.6986 37.829 18.7803L37.7823 27.0586C37.7807 33.672 33.6707 37.782 27.054 37.782Z",
    fill: "#114DF2"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8611 26.1882H13.3027C12.6127 26.1882 12.0527 25.6282 12.0527 24.9382C12.0527 24.2482 12.6127 23.6882 13.3027 23.6882H27.8611C28.5511 23.6882 29.1111 24.2482 29.1111 24.9382C29.1111 25.6282 28.5511 26.1882 27.8611 26.1882Z",
    fill: "#114DF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.409 21.1882H13.0298C12.4904 21.1882 12.0527 20.6282 12.0527 19.9382C12.0527 19.2482 12.4904 18.6882 13.0298 18.6882H24.409C24.9484 18.6882 25.3861 19.2482 25.3861 19.9382C25.3861 20.6282 24.9484 21.1882 24.409 21.1882Z",
    fill: "#114DF2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder);
export default __webpack_public_path__ + "static/media/icon-folder.aaa1d029a2e4379cbe2248972ecaa9bc.svg";
export { ForwardRef as ReactComponent };